import Page from './components/Page'
import { CONVERSATIONS_PAGE } from './pages'

export default {
  [CONVERSATIONS_PAGE]: {
    path: '/reports/inbox/conversations',
    component: Page,
  },
}
